import { IServerResponse, IConnectionStatus, ConnectionState } from '@/app-modules/server-communications';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';

export class ConnectionStatusConnectingResponse {
    public static filter(response: IConnectionStatus): boolean {
        return response.STATE === ConnectionState.CONNECTING;
    }

    public static asStream(response$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>): Observable<{}> {
        return connectionStatus$.switchMap((data) => Observable.of(data)
            .filter(ConnectionStatusConnectingResponse.filter)
            .catch((error) => {
                // error$.next(error)
                return Observable.empty<{}>();
            })).share();
    }
}

export class ConnectionStatusConnectedResponse {
    public static filter(response: IConnectionStatus): boolean {
      return response.STATE === ConnectionState.CONNECTED;
    }

    public static asStream(response$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>): Observable<{}> {
        return connectionStatus$.switchMap((data) => Observable.of(data)
            .filter(ConnectionStatusConnectedResponse.filter)
            .catch((error) => {
                // error$.next(error)
                return Observable.empty<{}>();
            })).share();
    }
}

export class ConnectionStatusConnectionLostResponse {
    public static filter(response: IConnectionStatus): boolean {
      return response.STATE === ConnectionState.CONNECTION_LOST;
    }

    public static asStream(response$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>): Observable<{}> {
        return connectionStatus$.switchMap((data) => Observable.of(data)
            .filter(ConnectionStatusConnectionLostResponse.filter)
            .catch((error) => {
                // error$.next(error)
                return Observable.empty<{}>();
            })).share();
    }
}

export class ConnectionStatusDisconnectedResponse {
    public static filter(response: IConnectionStatus): boolean {
      return response.STATE === ConnectionState.DISCONNECTED;
    }

    public static asStream(response$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>): Observable<{}> {
        return connectionStatus$.switchMap((data) => Observable.of(data)
            .filter(ConnectionStatusDisconnectedResponse.filter)
            .catch((error) => {
                // error$.next(error)
                return Observable.empty<{}>();
            })).share();
    }
}

export class ConnectionStatusDisconnectingResponse {
    public static filter(response: IConnectionStatus): boolean {
      return response.STATE === ConnectionState.DISCONNECTING;
    }

    public static asStream(response$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>): Observable<{}> {
        return connectionStatus$.switchMap((data) => Observable.of(data)
            .filter(ConnectionStatusDisconnectingResponse.filter)
            .catch((error) => {
                // error$.next(error)
                return Observable.empty<{}>();
            })).share();
    }
}

export class ConnectionStatusRetryCircuitBrokenResponse {
    public static filter(response: IConnectionStatus): boolean {
      return response.STATE === ConnectionState.RETRY_CIRCUIT_BROKEN;
    }

    public static asStream(response$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>): Observable<{}> {
        return connectionStatus$.switchMap((data) => Observable.of(data)
            .filter(ConnectionStatusRetryCircuitBrokenResponse.filter)
            .catch((error) => {
                // error$.next(error)
                return Observable.empty<{}>();
            })).share();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/connection-status/index.ts